/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1716
 */

"use strict"

var r = require(/* 86 */"../1650/86/index")
var /* [auto-meaningful-name] */require_1275_$_1275$end = require(/* 1275 */"./1275").end
r({
  target: "String",
  proto: true,
  forced: require(/* 1276 */"./1276")
}, {
  padEnd: function (e) {
    return require_1275_$_1275$end(this, e, arguments.length > 1 ? arguments[1] : undefined)
  }
})
